export const ALLOWED_IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif"];
export const ALLOWED_FILE_EXTENSIONS = ["txt", "docx", "pdf", "pptx"];
